import { Card, CardContent } from '@/components/ui/card';
import { Battery, TrendingUp, Radio, Sun } from 'lucide-react';

export const CoreFunctionsSection = () => {
  const functions = [
    {
      icon: Battery,
      title: 'USV-Ersatz & Backup',
      description:
        'BESS übernimmt die Rolle klassischer USV-Systeme mit höherer Kapazität, längerer Laufzeit und wartungsarmer Technologie.',
    },
    {
      icon: TrendingUp,
      title: 'Peak Shaving',
      description:
        'Lastspitzen werden gekappt, indem gespeicherte Energie bei Spitzenlast gezielt eingespeist wird – das schützt das Netz und reduziert Netzentgelte.',
    },
    {
      icon: Radio,
      title: 'Frequenzregelung',
      description:
        'BESS reagiert in Millisekunden auf Frequenzabweichungen und stabilisiert damit aktiv das Stromnetz.',
    },
    {
      icon: Sun,
      title: 'Erneuerbare Integration',
      description:
        'Überschussenergie aus Solar- oder Windquellen wird gespeichert und bedarfsgerecht ins System eingespeist.',
    },
  ];

  return (
    <section id="functions" className="py-12 sm:py-20 gradient-dark text-primary-foreground">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl mb-6">
            Kernfunktionen von BESS in Rechenzentrumsumgebungen
          </h2>
        </div>

        {/* Schema-Bild */}
        <div className="max-w-6xl mx-auto mb-12">
          <img
            src="https://customer-assets.emergentagent.com/job_462b1c9b-939c-4705-8ff2-b6f811719f70/artifacts/wwkgy6qe_Schema.png"
            alt="BESS-Kernfunktionen – Systemübersicht"
            className="w-full rounded-lg shadow-lg"
            loading="lazy"
            data-testid="core-functions-schema-image"
          />
        </div>

        {/* Functions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {functions.map((func, index) => (
            <Card
              key={index}
              className="bg-card/5 backdrop-blur-sm border-primary-foreground/10 hover:border-primary/50 transition-all duration-300 hover:shadow-glow group"
            >
              <CardContent className="p-8">
                {/* Icon & Title */}
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/30 transition-colors">
                    <func.icon className="w-6 h-6 text-primary-glow" />
                  </div>
                  <h3 className="font-heading font-bold text-2xl pt-2 text-white">
                    {func.title}
                  </h3>
                </div>

                {/* Description */}
                <p className="text-primary-foreground/80 leading-relaxed pl-16">
                  {func.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};